import styled from "styled-components";

export const Container = styled.div`
  min-width: 30vw;
  max-width: 30vw;
  width: 30vw;
`;
